import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from '@mui/material';

const ConsentForm = ({ open, onClose }) => {
  const [isConsentGiven, setIsConsentGiven] = useState(false);

  const handleConsentChange = (event) => {
    setIsConsentGiven(event.target.checked);
  };

  const handleSubmit = () => {
    if (isConsentGiven) {
      onClose(true);
      setIsConsentGiven(false);
    } else {
      alert('You must agree to the terms to proceed.');
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose(false)}>
      <DialogTitle sx={{ fontSize: '1.5rem' }}>
        Consent to Access Your Email for Partnership
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" sx={{ fontSize: '1.1rem', mb: 2 }}>
          Follow these simple steps to complete the partnership sign-up process:
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>1.</strong> Click "Agree" to start the sign-in process.
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>2.</strong> You will be redirected to Google’s sign-in page. When you arrive, you must grant all the permissions that are requested.
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>3.</strong> If a message appears saying "This app is unverified," click “Advanced” and then “Continue” to proceed.
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          By choosing to become a Partner, you allow Blitz Corp to access your email account for verification. This ensures that we manage your brand deals effectively. Without completing this process, you will remain as an Associate with limited benefits.
        </Typography>
        <FormControlLabel
          control={<Checkbox checked={isConsentGiven} onChange={handleConsentChange} />}
          label="I understand and agree to the above terms."
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} color="primary" variant="text">
          Cancel
        </Button>
        <Button onClick={handleSubmit} disabled={!isConsentGiven} color="primary" autoFocus variant="text">
          Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConsentForm;
